import * as React from 'react';
import { useIntl } from 'react-intl';

export function LoadingText(): JSX.Element {
  const { formatMessage: f } = useIntl();

  return (
    <div className="flex justify-center w-full bg-white absolute bottom-0 left-0 z-10">
      <h4 className="text-black font-bold">{f({ id: 'waypoints.loading' })}</h4>
    </div>
  );
}
